import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  padding: 4px 16px;
  background-color: ${props => props.theme.bodyColor};
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 44px;
`;

const Text = styled.span`
  font: ${props => props.theme.fontWeightBold} 10px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
`;

export default function buildTooltipContent({ valueContent }) {
  function TooltipContent({
    active, payload, label, labelFormatter,
  }) {
    if (!active) {
      return null;
    }

    return (
      <Container>
        {valueContent({ payload })}
        <Text>{labelFormatter(label)}</Text>
      </Container>
    );
  }

  TooltipContent.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.number.isRequired,
    })).isRequired,
    label: PropTypes.string.isRequired,
    labelFormatter: PropTypes.func.isRequired,
  };

  TooltipContent.defaultProps = {
    active: false,
  };

  return TooltipContent;
}
